<!-- TODO: Update content and styling when design is updated -->

<trds-layout>
    <h1>Insufficient Permissions</h1>
    <p>You do not have access permissions.</p>
</trds-layout>
